"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoleText = exports.UserRoles = void 0;
var UserRoles;
(function (UserRoles) {
    UserRoles["ENTERPRISE"] = "enterprise";
    UserRoles["SUPER_ADMIN"] = "super_admin";
    UserRoles["PARENT_USER"] = "parent_user";
    UserRoles["USER"] = "user";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
;
const getRoleText = (userRole) => {
    switch (userRole) {
        case UserRoles.SUPER_ADMIN: return 'user.roles.super_admin'.t();
        case UserRoles.PARENT_USER: return 'user.roles.parent_user'.t();
        case UserRoles.ENTERPRISE: return 'user.roles.enterprise'.t();
    }
    return 'user.roles.user'.t();
};
exports.getRoleText = getRoleText;
